// extracted by mini-css-extract-plugin
export default {"container":"ImagesCarouselModal_container__oLTmM"};